
import LogoImg from '../../../assets/image/logoSeeWard.png';
import LogoImgMin from '../../../assets/image/blue.png';
import LogoWithImg from '../../../assets/image/logoSeeWardWhite.png';
import { Typography } from 'antd';
import Bg_Img from '../../../assets/image/login_bg.png';
// const Logo = () => (
//   <NavLink to='/'>
//     <img
//       src={LogoImgWhite}
//       alt='logo'
//     />
interface LoginLayoutProps {
  children: React.ReactNode
  /** The line above the heading. Sign-in's own wording unless a screen gives its own. */
  eyebrow?: string
  title?: string
}

const LoginLayout: React.FC<LoginLayoutProps> = ({
  children,
  eyebrow = 'Start your journey',
  title = 'Sign In to SeeWard'
}) => <div>
  <section className="bg-white">
    <div className="lg:grid lg:min-h-screen lg:grid-cols-12">
      <section
        className="relative flex h-32 items-end bg-gray-900 lg:col-span-5 lg:h-full xl:col-span-6"
      >
        <img
          alt=""
          src={Bg_Img}
          className="absolute inset-0 h-full w-full object-cover opacity-100 "
        />

        <div className="hidden lg:relative lg:block lg:p-12">
          <img src={LogoWithImg} className='w-40' />

          <h2
            className="mt-6 text-2xl font-bold text-white sm:text-3xl md:text-4xl"
          >
            Welcome to SeeWard
          </h2>

          <p className="mt-4 leading-relaxed text-white/90">
            Seeward combines all the asset information, vulnerability data from scanning tools,
            and threat intelligence into one single platform for vulnerability teams
            to eliminate laborious manual data analysis and accelerate decision-making and prioritization.
          </p>
        </div>
      </section>

      <main
        className="flex items-center justify-center px-8 py-8 sm:px-12 lg:col-span-7 lg:px-16 lg:py-12 xl:col-span-6"
      >
        <div className="max-w-xl lg:max-w-3xl w-full">
          <div className="relative -mt-16 block lg:hidden">
            <a
              className="inline-flex size-16 items-center justify-center rounded-full bg-white text-blue-600 sm:size-20"
              href="#"
            >
              <img src={LogoImgMin} alt="" className="h-15 w-15 p-1.5" />
            </a>

            <Typography.Title
              level={5}
              className="mt-2 text-2xl font-bold text-gray-900 sm:text-3xl md:text-4xl hidden lg:block"
            >
              Welcome to SeeWard
            </Typography.Title >

            <p className="mt-4 leading-relaxed text-gray-500 hidden lg:block">
              Lorem, ipsum dolor sit amet consectetur adipisicing elit. Eligendi nam dolorum aliquam,
              quibusdam aperiam voluptatum.
            </p>
          </div>
          <div className="lg:w-[500px]">
            <span className="mb-1.5 block font-medium">
              {eyebrow}
            </span>
            <h2
              className="mb-9 text-2xl font-bold text-black dark:text-white sm:text-title-xl2"
            >
              {title}
            </h2>

            {children}
          </div>
        </div>
      </main>
    </div>
  </section>
</div>;

export default LoginLayout;